//  buildify
import '@adornis/buildify/client/components/x-icon-button.js';
import '@adornis/buildify/client/components/x-infobox.js';
import '@adornis/buildify/client/editors/x-buildify-inline-editor.js';
import '@adornis/buildify/client/extensions/AccordeonExtension.js';
import '@adornis/buildify/client/extensions/ContainerExtension.js';
import '@adornis/buildify/client/extensions/ContainerFlexExtension.js';
import '@adornis/buildify/client/extensions/ContainerGridExtension.js';
import '@adornis/buildify/client/extensions/ContainerSectionExtension.js';
import '@adornis/buildify/client/extensions/IconExtension.js';
import '@adornis/buildify/client/extensions/IconTextExtension.js';
import '@adornis/buildify/client/extensions/ImageExtension.js';
import '@adornis/buildify/client/extensions/ImageFlipcardExtension.js';
import '@adornis/buildify/client/extensions/ListExtension.js';
import '@adornis/buildify/client/extensions/SpacingExtension.js';
import '@adornis/buildify/client/extensions/TagExtension.js';
import '@adornis/buildify/client/extensions/TextExtension.js';
import '@adornis/buildify/client/extensions/VimeoExtension.js';
import '@adornis/buildify/client/extensions/YoutubeExtenions.js';
import '@adornis/buildify/client/x-buildify-dropzone.js';
import '@adornis/buildify/client/x-buildify-toolbar.js';
import '@adornis/buildify/client/x-buildify-visualization.js';
import '@adornis/chemistry/elements/components/stack/x-stack.js';

// -- buildify end --
import '@adornis/buildify/client/components/x-buildify-aspect-ratio-picker.js';
import '@adornis/buildify/client/components/x-buildify-border-radius-picker.js';
import '@adornis/buildify/client/components/x-buildify-color-picker.js';
import '@adornis/buildify/client/components/x-buildify-drawer-wrapper.js';
import '@adornis/buildify/client/components/x-buildify-file-selection.js';
import '@adornis/buildify/client/components/x-buildify-global-settings.js';
import '@adornis/buildify/client/components/x-buildify-page-settings.js';
import '@adornis/buildify/client/components/x-buildify-size-picker.js';
import '@adornis/buildify/client/components/x-buildify-spacing-picker.js';
import '@adornis/buildify/client/components/x-infobox.js';
import '@adornis/chemistry/elements/components/x-card.js';
import '@adornis/chemistry/elements/components/x-chip.js';
import '@adornis/chemistry/elements/components/x-empty-placeholder.js';
import '@adornis/chemistry/elements/components/x-hr.js';
import '@adornis/chemistry/elements/components/x-list.js';
import '@adornis/chemistry/elements/components/x-overlay.js';
import '@adornis/chemistry/elements/components/x-section.js';
import '@adornis/chemistry/elements/components/x-toggle-content.js';
import '@adornis/chemistry/elements/components/x-tree-view.js';
import { DesignSystem } from '@adornis/chemistry/elements/theming/design.js';
import { setGlobalStyle } from '@adornis/chemistry/elements/theming/global-style.js';
import { Spacing } from '@adornis/chemistry/elements/theming/spacings.js';
import { createComponentsFromChemistryBase } from '@adornis/chemistry/elements/x-components.js';
import '@adornis/data-view/client/legacy/x-data-view-card-list.js';
import '@adornis/data-view/client/legacy/x-sorting-card.js';
import '@adornis/datetime/x-basic-date-picker.js';
import '@adornis/datetime/x-date-picker-dropdown.js';
import '@adornis/dialog/x-drawer-panel.js';
import '@adornis/dragdrop/x-drag-drop.js';
import '@adornis/entity-picker/client/x-entity-picker.js';
import '@adornis/entity-picker/client/x-multi-entity-picker.js';
import '@adornis/excalidraw/client/x-excalidraw.js';
import '@adornis/field-management/x-field-selection-drawer.js';
import '@adornis/file-utils/client/x-file-input.js';
import { addFontData } from '@adornis/fonts/font-resets.js';
import '@adornis/forms/x-plain-input.js';
import '@adornis/forms/x-radiogroup.js';
import '@adornis/internationalization/client/language-picker/x-country-picker.js';
import '@adornis/mails/client/x-recipient-preview.js';
import '@adornis/popover/x-dropdown.js';
import '@adornis/popover/x-tooltip.js';
import '@adornis/user-forms/x-login-input.js';
import '@adornis/user-forms/x-password-reset.js';
import '@adornis/writer/x-tinymce.js';

// buildify components
import type { Styles } from '@adornis/ass/style.js';
// buildify extension editors
import '@adornis/buildify/client/extensions/AccordeonExtension.js';
import '@adornis/buildify/client/extensions/ButtonExtension.js';
import '@adornis/buildify/client/extensions/ContainerExtension.js';
import '@adornis/buildify/client/extensions/ContainerFlexExtension.js';
import '@adornis/buildify/client/extensions/ContainerGridExtension.js';
import '@adornis/buildify/client/extensions/ContainerSectionExtension.js';
import '@adornis/buildify/client/extensions/ExcalidrawExtension.js';
import '@adornis/buildify/client/extensions/H1Extension.js';
import '@adornis/buildify/client/extensions/H2Extension.js';
import '@adornis/buildify/client/extensions/H3Extension.js';
import '@adornis/buildify/client/extensions/IconExtension.js';
import '@adornis/buildify/client/extensions/IconTextExtension.js';
import '@adornis/buildify/client/extensions/ImageExtension.js';
import '@adornis/buildify/client/extensions/ImageFlipcardExtension.js';
import '@adornis/buildify/client/extensions/ListExtension.js';
import '@adornis/buildify/client/extensions/SpacingExtension.js';
import '@adornis/buildify/client/extensions/TagExtension.js';
import '@adornis/buildify/client/extensions/TextExtension.js';
import '@adornis/buildify/client/extensions/VimeoExtension.js';
import '@adornis/buildify/client/extensions/YoutubeExtenions.js';
import '@adornis/buildify/client/extensions/x-extension-editor.js';

import { XHorizontalRule } from '@adornis/chemistry/elements/components/x-hr.js';
import { customElement } from 'lit/decorators.js';
import 'copy:../tailwind.css' with { type: 'tailwind' };
export const baseFontSize = 16;
export const baseFontSizeTablet = 14;
export const baseFontSizeMobile = 12;
export const baseFontSizeMobileSmall = 10;

export const fontFamily = 'Montserrat';
export const fontFamilyText = 'normal';

export const crSpacing = {
  xxs: Spacing.make(2, 'px'),
  xs: Spacing.make(5, 'px'),
  sm: Spacing.make(8, 'px'),
  md: Spacing.make(13, 'px'),
  lg: Spacing.make(20, 'px'),
  xl: Spacing.make(28, 'px'),
  xxl: Spacing.make(62, 'px'),

  landing: '192px',
};

export const colors = {
  chancen_green_primary: '#AFCA00',
  chancen_orange_secondary: '#E28807',
  chancen_blue_accent: '#59b7ff', // tone.info: fehlerhafte Zuteilung / fehlende Angaben

  grey: '#DFDFDF',
  subtle: '#a2a2a2',
  black: '#000000',
  background: '#f6f6f6',
  darkgreen: '#036359',

  neutral: '#B7B7B7',

  darkerBackground: '#e7e7e7',

  red: '#de140d',
} as const;

DesignSystem.prefix = 'cr';

@customElement('cr-hr')
export class CRHR extends XHorizontalRule {
  override styles(): any {
    return [...super.styles(), { background: this.colors.neutral.shade(300) }] as Styles[];
  }
}

createComponentsFromChemistryBase<'x'>(
  'x-accordeon-extension',
  'x-basic-date-picker',
  'x-buildify-aspect-ratio-picker',
  'x-buildify-border-radius-picker',
  'x-buildify-color-picker',
  'x-buildify-color-picker-dropdown-content',
  'x-buildify-default-editor',
  'x-buildify-dropzone',
  'x-buildify-global-settings',
  'x-buildify-global-settings-border-picker',
  'x-buildify-global-settings-border-radius-picker',
  'x-buildify-global-settings-color-picker',
  'x-buildify-global-settings-spacing-picker',
  'x-buildify-global-settings-width-picker',
  'x-buildify-inline-editor',
  'x-buildify-page-settings',
  'x-buildify-size-picker',
  'x-buildify-width-picker',
  'x-buildify-spacing-picker',
  'x-buildify-toolbar',
  'x-buildify-visualization',
  'x-component-password-checker',
  'x-container-flex-extension',
  'x-container-grid-extension',
  'x-country-picker',
  'x-data-view-card-list',
  'x-drag-drop',
  'x-drawer-panel',
  'x-dropdown',
  'x-empty-placeholder',
  'x-entity-picker',
  'x-excalidraw',
  'x-extension-editor',
  'x-field-selection-drawer',
  'x-file-input',
  'x-icon-button',
  'x-icon-extension',
  'x-icon-text-extension',
  'x-image-extension',
  'x-image-flipcard-extension',
  'x-infobox',
  'x-list-extension',
  'x-list-item',
  'x-login-input',
  'x-multi-entity-picker',
  'x-overlay',
  'x-plain-input',
  'x-radiogroup',
  'x-recipient-preview',
  'x-section',
  'x-section-extension',
  'x-sorting-card',
  'x-spacing-extension',
  'x-stack',
  'x-stack-breadcrumb',
  'x-tag-extension',
  'x-text-extension',
  'x-tinymce',
  'x-tree-view',
  'x-vimeo-extension',
  'x-youtube-extension',
);

const theme = DesignSystem.extendBase(
  {
    spacing: crSpacing,
    baseFontSize,
    baseFontSizePrint: baseFontSize,
    fontFamily,
    defaults: {
      placeholderMode: 'inline-floating',
    },
    borders: {},
    sizes: {
      borderRadius: '25px',
      borderRadiusSecondary: '7px',
      maxReadableWidth: '500px',
      maxPageWidth: '1080px',
    } as any,
  },

  {
    primary: colors.chancen_green_primary,
    secondary: colors.chancen_orange_secondary,
    accent: colors.chancen_orange_secondary,
    neutral: colors.neutral,
    tone: {
      active: colors.chancen_green_primary,
      success: colors.chancen_green_primary,
      warning: colors.chancen_orange_secondary,
      error: colors.red,
      // Hinweis-Ton: etwas stimmt an den Daten nicht, die Person ist aber weder inaktiv noch ausgetreten.
      info: colors.chancen_blue_accent,
      subtle: colors.subtle,
      placeholder: colors.subtle,
      darkerBackground: colors.darkerBackground,
    },
  },
);

DesignSystem.setTheme('chromium', theme);

DesignSystem.useTheme('chromium');

addFontData('Indie Flower', {
  descenderHeightRatio: 0,
});

const scrollBarStyles = {
  '::-webkit-scrollbar': {
    width: '10px',
    height: '10px',
  },
  '::-webkit-scrollbar-track': {
    // background: DesignSystem.getTheme('chromium')?.colors.neutral.shade(200),
    background: 'transparent',
  },

  '::-webkit-scrollbar-thumb:hover': {
    'background-color': DesignSystem.getTheme('chromium')?.colors.primary,
  },

  '::-webkit-scrollbar-thumb:active': {
    'background-color': DesignSystem.getTheme('chromium')?.colors.primary,
  },

  '::-webkit-scrollbar-thumb': {
    'background-color': DesignSystem.getTheme('chromium')?.colors.primary.shade(300),
    transition: 'all 0.25s ease-in-out',
    borderRadius: '10px',
  },
};

const selectionStyles = {
  '::selection': { color: 'white', background: DesignSystem.getTheme('chromium')?.colors.primary },
};

if (navigator.userAgent.search('Firefox')) {
  setGlobalStyle(() => ({
    ...selectionStyles,
  }));
} else {
  // @ts-expect-error designsystem color is converted but not type converted
  setGlobalStyle(() => ({
    ...selectionStyles,
    ...scrollBarStyles,
  }));
}
